import { FintrafficThemeProvider } from "./FintrafficThemeProvider";
export default FintrafficThemeProvider;
